'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { EERIE, KOALA } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIFolderNavItem from 'UIComponents/nav/UIFolderNavItem';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import { FilePropTypes, FolderPropTypes } from 'DesignData/propTypes/finder';
import * as finderSelectors from 'DesignData/selectors/finder';

const makeMapStateToProps = () => {
  return (state, props) => {
    const progress = finderSelectors.getFileUploadProgress(state, props);
    return {
      progress
    };
  };
};

const MiniSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "FileUploadNode__MiniSpinner",
  componentId: "sc-3j2c5q-0"
})(["height:14px;right:7px;width:14px;margin-right:1px;"]);

const FileUploadNode = props => {
  return /*#__PURE__*/_jsx(UIFolderNavItem, {
    disabled: true,
    iconLeft: /*#__PURE__*/_jsx(MiniSpinner, {}),
    style: {
      backgroundColor: KOALA
    },
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UINanoProgress, {
        value: props.progress,
        animateOnComplete: props.progress === 100
      }), /*#__PURE__*/_jsx("span", {
        style: {
          color: EERIE,
          left: '25px'
        },
        children: props.fileName
      })]
    })
  });
};

FileUploadNode.propTypes = {
  fileName: FilePropTypes.fileName.isRequired,
  // eslint-disable-next-line
  folderId: FolderPropTypes.folderId,
  progress: PropTypes.number.isRequired
};
export default connect(makeMapStateToProps)(FileUploadNode);